import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import toast from "react-hot-toast";
import SideModal from "../SideModal/SideModal";
import { instrument } from "../../constants/instruments";
import InstructorService from "../../services/instructor.service";
import { countries, foreignCountries } from "../../utilis/country.utiils";
import { IoIosAddCircle, IoIosRemoveCircle } from "react-icons/io";

interface ICreateCourseModal {
  instructorId: string;
  setInstructorId: (id: string | undefined) => void;
}

export default function CreateCourseModal(props: ICreateCourseModal) {
  const [title, setTitle] = useState("");
  const [selInstrument, setSelInstrument] = useState<any>(null);
  const [pricePerClass, setPricePerClass] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [countriesList, setCountriesList] = useState<{ country: any; discount: { num_classes: string; discount: string }[] }[]>([]);



  const handleDiscountChange = (countryIndex: number, discountIndex: number, key: "num_classes" | "discount", value: string) => {
    const updatedCountries = [...countriesList];
    updatedCountries[countryIndex].discount[discountIndex][key] = value;
    setCountriesList(updatedCountries);
  };

  const addCountry = () => {
    setCountriesList([...countriesList, { country: null, discount: [] }]);
  };

  const removeCountry = (index: number) => {
    setCountriesList(countriesList.filter((_, i) => i !== index));
  };

  const addDiscount = (countryIndex: number) => {
    const updatedCountries = [...countriesList];
    updatedCountries[countryIndex].discount.push({ num_classes: "0", discount: "0" });
    setCountriesList(updatedCountries);
  };

  const removeDiscount = (countryIndex: number) => {
    const updatedCountries = [...countriesList];
    updatedCountries[countryIndex].discount.pop();
    setCountriesList(updatedCountries);
  };

  const createCourse = async () => {
    if (!title || !selInstrument || !pricePerClass) {
      toast.error("All Fields are Mandatory!");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        instructor: props.instructorId,
        title: title,
        instrument: selInstrument.value,
        price_per_class: Number(pricePerClass),
        international_discounts: countriesList
      }
      const res = await InstructorService.createCourse(payload);
      if (res.status === 200) {
        toast.success("Course Created");
        props.setInstructorId(undefined);
      }
    } catch (e: any) {
      toast.error(e.response?.data || "Something Went Wrong");
    }
    setLoading(false);
  };

  return (
    <SideModal
      show={!!props.instructorId}
      handleClose={() => props.setInstructorId(undefined)}
      title="Add Course"
      body={
        <div className="h-100">
          <Form.Group className="mt-3">
            <Form.Label>Subject</Form.Label>
            <Select onChange={setSelInstrument} options={instrument} value={selInstrument} />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Title</Form.Label>
            <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Price Per Class</Form.Label>
            <Form.Control type="number" value={pricePerClass} onChange={(e) => setPricePerClass(e.target.value)} />
          </Form.Group>
          <div className="d-flex justify-content-end align-items-center mt-3">
            {/* <h6>Countries</h6> */}
            <IoIosAddCircle className="text-success" style={{ fontSize: "25px", cursor: "pointer" }} onClick={addCountry} />
          </div>
          {countriesList.map((entry, countryIndex) => (
            <Card key={countryIndex} className="mt-3 p-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h6>Country</h6>
                <IoIosRemoveCircle className="text-danger" style={{ fontSize: "25px", cursor: "pointer" }} onClick={() => removeCountry(countryIndex)} />
              </div>
              <Form.Group>
                <Select
                  options={foreignCountries.map((c) => ({ label: c, value: c }))}
                  // value={entry.country}
                  onChange={(selected: any) => {
                    const updatedCountries = [...countriesList];
                    updatedCountries[countryIndex].country = selected.value;
                    setCountriesList(updatedCountries);
                  }} />
              </Form.Group>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <h6>Discounts</h6>
                <IoIosAddCircle className="text-success" style={{ fontSize: "25px", cursor: "pointer" }} onClick={() => addDiscount(countryIndex)} />
              </div>
              {entry?.discount?.map((discount: any, discountIndex: number) => (
                <div className=" bg-light rounded">
                  <Form.Group key={discountIndex} className="mt-2 p-2 bg-light rounded">
                    <Row className="align-items-center">
                      <Col md={2} style={{ fontSize: 12 }}>Buy</Col>
                      <Col md={3}>
                        <Form.Control type="number" value={discount.num_classes} onChange={(e) => handleDiscountChange(countryIndex, discountIndex, "num_classes", e.target.value)} />
                      </Col>
                      <Col md={2} style={{ fontSize: 12 }}>Get</Col>
                      <Col md={3}>
                        <Form.Control type="number" value={discount.discount} onChange={(e) => handleDiscountChange(countryIndex, discountIndex, "discount", e.target.value)} />
                      </Col>
                      <Col md={2} style={{ fontSize: 12 }}>% Off</Col>
                    </Row>
                  </Form.Group>
                  <div className="mt-1 d-flex justify-content-end p-2">
                    <IoIosRemoveCircle className="text-danger" style={{ fontSize: "20px", cursor: "pointer" }} onClick={() => removeDiscount(countryIndex)} />
                  </div>
                </div>
              ))}
            </Card>
          ))}
          <Button variant="secondary" disabled={loading} className="mt-3 w-100" onClick={createCourse}>
            {loading ? "Creating..." : "Create Course"}
          </Button>
        </div>
      }
    />
  );
}
